<template>
  <otif-modal
    ref="confirm-delete-row"
    title="Cancel Documents"
    :value="value"
    @input="$emit('input', $event)"
  >
    <p>Are you sure you want to cancel this upload?</p>
    <template slot="footer">
      <otif-button class="OTSecondary" @click.native="no">No</otif-button>
      <otif-button class="OTPrimary" @click.native="yes">Yes</otif-button>
    </template>
  </otif-modal>
</template>

<script>
import { EventBus } from "@mtm-studio/components/src/lib/eventBus.js";
export default {
  data() {
    return {
      Documents: null
    };
  },
  props: ["value", "rows"],
  methods: {
    no() {
      this.$emit("input", false);
    },

    async yes() {
      this.$snotify.info("Removing Documents", {
        timeout: 0
      });
      EventBus.$emit("loadServerDocuments", this.rows);
      this.$snotify.clear();
      this.$snotify.success("Removed browsed document(s)");
      this.$emit("deleted");
      this.$emit("input", false);
    }
  }
};
</script>
